import { ESubscriptionCancellationReason } from "@devowl-wp/api-real-commerce";
import { useMemo } from "react";
import { _i, __ } from "../utils";

/**
 * Get the subscription cancellation reason localized as object.
 */
function useAccountSubscriptionCancellationReason() {
  return useMemo(() => {
    const result = {};
    Object.keys(ESubscriptionCancellationReason).forEach(key => {
      let readOnly = false;
      let hint;
      const value = ESubscriptionCancellationReason[key];
      let localized = key;
      switch (value) {
        case ESubscriptionCancellationReason.ProductIssue:
          localized = __("(Technical) problem with the product");
          hint = _i(__("You need help? {{a}}Open a support ticket{{/a}} and an expert of our team will help you in a timely manner!"), {
            a: /*#__PURE__*/React.createElement("a", {
              target: "_blank",
              href: __("https://devowl.io/support/"),
              rel: "noreferrer"
            })
          });
          break;
        case ESubscriptionCancellationReason.BetterAlternativeFound:
          localized = __("Better alternative found");
          break;
        case ESubscriptionCancellationReason.TooExpensive:
          localized = __("Too expensive");
          break;
        case ESubscriptionCancellationReason.NoNeedAnymore:
          localized = __("No need for it anymore");
          break;
        case ESubscriptionCancellationReason.PaymentFailed:
          localized = __("Payment failed");
          readOnly = true;
          break;
        default:
          localized = __("No reason");
          break;
      }
      result[value] = {
        localized,
        key,
        value,
        readOnly,
        hint
      };
    });
    return result;
  }, []);
}
export { useAccountSubscriptionCancellationReason };